<button class="ga-to-compare" (click)="compare.emit()" [disabled]="disable"
  [attr.data-btnToCompare]="'Comparar - ' + product">
  <app-image [path]="'/assets/images/compare.svg'" class="ga-to-compare"
    [attr.data-btnToCompare]="'Comparar - ' + product"></app-image>
  {{ compareBtn}}
</button>